import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { ProgramBuilder } from '../../models/builders/program.builder';
import { Operation } from '../../models/operation';
import { Part } from '../../models/part';
import { Print } from '../../models/print';
import { Source } from '../../models/source';
import { valueOf } from '../../utils/string.utils';

@Injectable()
export class ProgramApiService {

  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }programs`;
  }

  getOperationsByPrintSourceAndPart(
    print: Print,
    part: Part,
    source: Source
  ) {
    const params = new HttpParams()
      .append('print', print.hash)
      .append('part', part.hash)
      .append('source', source.hash);

    return this.httpClient.get(`${ this.apiUrl }/operations`, { params })
      .pipe(
        map(ProgramBuilder.fromOperationList)
      );
  }

  getProgramsByPrintSourcePartAndOperation(
    print: Print,
    source: Source,
    part: Part,
    operation: Operation
  ) {
    let params = new HttpParams()
      .append('print', print.hash)
      .append('source', source.hash);

    if (part) {
      params = params.append('part', part.hash);
    }

    if (operation) {
      params = params.append('operation', operation.hash)
                  .append('operationIndex', valueOf(operation.index));
    }

    return this.httpClient.get(`${ this.apiUrl }`, { params })
      .pipe(
        map(ProgramBuilder.fromList)
      );
  }

  searchPrograms(search: string) {
    const params = new HttpParams().append('search', search);

    return this.httpClient.get(`${ this.apiUrl }/search`, { params })
      .pipe(
        map(ProgramBuilder.fromProgramManufacturingOrderList)
      );
  }

  getProgramsByValidation(validation: string) {
    const params = new HttpParams().append('validationHash', validation);

    return this.httpClient.get(`${ this.apiUrl }/by-validation`, { params })
      .pipe(
        map(ProgramBuilder.fromProgramManufacturingOrderList)
      );
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/program-api.service.ts